module.exports = __webpack_public_path__ + "img/JSD500.0f330a56.png";